<!--sidebar — RingOffice branded, light scheme to match LicensePortal / OneGate-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed border-end"
  colorScheme="light"
  id="sidebar1"
  visible
>
  <c-sidebar-header class="border-bottom">
    <c-sidebar-brand [routerLink]="[]">
      <div class="ro-sidebar-brand">
        <img
          src="assets/brand/ringoffice-logo-full.png"
          alt="RingOffice"
          class="ro-brand-logo"
        />
        @if (!sidebar1.narrow) {
          <span class="ro-brand-separator"></span>
          <span class="ro-brand-text">
            <strong>Order Manager</strong>
            <small>Order workflow</small>
          </span>
        }
      </div>
    </c-sidebar-brand>
  </c-sidebar-header>

  <ng-scrollbar
    #scrollbar="ngScrollbar"
    (updated)="onScrollbarUpdate(scrollbar.state)"
    class="overflow"
    pointerEventsMethod="scrollbar"
    visibility="hover"
  >
    <c-sidebar-nav #overflow [navItems]="navItems" dropdownMode="none" compact />
  </ng-scrollbar>

  @if (!sidebar1.narrow) {
    <c-sidebar-footer
      cSidebarToggle="sidebar1"
      class="border-top d-none d-lg-flex"
      toggle="unfoldable"
      style="cursor: pointer;"
    >
      <button cSidebarToggler aria-label="Toggle sidebar fold"></button>
    </c-sidebar-footer>
  }
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
  <!--app-header-->
  <app-default-header
    [cShadowOnScroll]="'sm'"
    class="mb-4 d-print-none header header-sticky p-0 shadow-sm"
    position="sticky"
    sidebarId="sidebar1"
  />
  <!--app-body-->
  <div class="body flex-grow-1">
    <c-container [fluid]="true" class="h-auto px-3 px-lg-4">
      <router-outlet />
      <c-toaster [placement]="'top-end'"></c-toaster>
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer />
</div>

<!--aside-->
<app-default-aside style="display: none;" />
